<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.userName"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
    };
  },
  created() {},
  methods: {
    query() {
      this.$emit("search", { ...this.filters });
    },
    reset() {
      this.filters = {};
      this.$emit("reset");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
  